// Brand asset URLs (provided by Chelsea)
export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_quiz-flow-11/artifacts/fcs6bpvz_CL%20Clarity%20Coach%20Emblem%20Sage%20Stacked.png",
  hero_bw_serious: "https://customer-assets.emergentagent.com/job_quiz-flow-11/artifacts/prot0zt4_DSC07024.jpg",
  results_color_smile: "https://customer-assets.emergentagent.com/job_quiz-flow-11/artifacts/bgnekwwc_DSC06808.jpg",
  interstitial_bw_arms: "https://customer-assets.emergentagent.com/job_quiz-flow-11/artifacts/fitsgs50_DSC07617.jpg",
  email_gate_juggling: "https://customer-assets.emergentagent.com/job_quiz-flow-11/artifacts/1z8w7x3k_IMG_1499%20%281%29.jpg",
};
